import script from "./ReportHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fadc93f0"]])

export default __exports__